var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.85884 17.7999L7.85884 18.0499L8.10884 18.0499L17.8386 18.0499L18.0886 18.0499L18.0886 17.7999L18.0886 2.19953L18.0886 1.94953L17.8386 1.94953L8.10884 1.94952L7.85884 1.94952L7.85884 2.19952L7.85884 3.31849C7.85884 3.77749 7.48675 4.14958 7.02776 4.14958C6.56877 4.14958 6.19668 3.77749 6.19668 3.3185L6.19668 2.19952C6.19668 1.68095 6.39918 1.18448 6.75827 0.819089C7.11722 0.453851 7.60312 0.249472 8.10884 0.249473L17.8386 0.249473C18.3443 0.249473 18.8302 0.453852 19.1891 0.81909C19.5482 1.18448 19.7507 1.68095 19.7507 2.19953L19.7507 17.7999C19.7507 18.3185 19.5482 18.815 19.1891 19.1804C18.8302 19.5456 18.3443 19.75 17.8386 19.75L8.10884 19.75C7.60312 19.75 7.11722 19.5456 6.75827 19.1804C6.39918 18.815 6.19668 18.3185 6.19668 17.7999L6.19668 16.681C6.19668 16.222 6.56877 15.8499 7.02776 15.8499C7.48675 15.8499 7.85884 16.222 7.85884 16.681L7.85884 17.7999Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14043 10.8499L3.54583 10.8499L3.96178 11.2748L6.00426 13.3611C6.3237 13.6874 6.32319 14.2093 6.00313 14.535C5.67465 14.8693 5.13594 14.8693 4.80746 14.535L0.350411 9.99987L4.80746 5.46471C5.13594 5.13047 5.67465 5.13047 6.00313 5.46471C6.32319 5.79039 6.3237 6.31233 6.00426 6.63863L3.96178 8.72495L3.54583 9.14984L4.14043 9.14984L13.4945 9.14984C13.9639 9.14984 14.3445 9.53041 14.3445 9.99987C14.3445 10.4693 13.9639 10.8499 13.4945 10.8499L4.14043 10.8499Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.a8de705a232b2e931109d7cff47772fa.svg";
export { ForwardRef as ReactComponent };